import { RouterPage } from 'APP/router/constants';

export const getSpaceLink = (spaceId) => {
  return `/${RouterPage.Spaces}/${spaceId}`;
};

export const getSpaceAbsoluteLink = (spaceId) => {
  return `${window.location.origin}${getSpaceLink(spaceId)}`;
};
